/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "b8537dab52fe0b53d567a22f3aad7aa3cdc17277";
